var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExpandLess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3339 12.2471L10.1479 9.06105C10.0665 8.97969 9.9346 8.97969 9.85324 9.06105L6.66722 12.2471L5.78334 11.3632L8.96936 8.17717C9.53887 7.60765 10.4622 7.60765 11.0318 8.17717L14.2178 11.3632L13.3339 12.2471Z",
    fill: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExpandLess);
export default __webpack_public_path__ + "static/media/icon_expand_less.ac3747bda8038d1d83a99f9036db0cf7.svg";
export { ForwardRef as ReactComponent };